import React, { useCallback, useEffect, useState } from "react";
import CorporateLayout from "../Layout";
import HubHeader from "../Layout/topHeader";
import Loading from "../../common/Loader";
import { Drawer, Empty } from "antd";
import { authenticateToken } from "../../../utils/auth";
import axios from "axios";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import moment from "moment";

const TopUpDetailsList = ({ params }: any) => {
  const { corporateInfo } = useSelector((state) => (state as any)?.authReducer);
  const route = useParams();
  const [selectedData, setSelectedData] = useState(null);

  const [topupData, setTopupData] = useState({
    loading: false,
    data: null,
  });

  const getTopupHistory = useCallback(async () => {
    setTopupData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_TOPUP_API}`;
    axios
      .get(
        `${encodedUri}/admin/topup/company-history-details?companyTopUpId=${
          (route as any).topupId
        }`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setTopupData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setTopupData({ loading: false, data: [] });
        console.error("Users: Error", err);
      });
  }, [route]);

  useEffect(() => {
    getTopupHistory();
  }, [getTopupHistory]);

  const onClose = () => {
    setSelectedData(null);
  };

  return (
    <React.Fragment>
      <CorporateLayout corporateId={corporateInfo?.id}>
        <div className="product-list-item-area white-bg">
          <HubHeader leftarea={"TopUp Details"} rightarea={``} />

          <div className="product-list-item-area white-bg section-padding-bottom">
            <div className="">
              <div className="">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    <div className="single-product-heading">
                      <span>User Name</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Mobile Number</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Designation</span>
                    </div>
                    <div className="single-product-heading">
                      <span>TopUp Id</span>
                    </div>
                    <div className="single-product-heading text-right">
                      <span>Status</span>
                    </div>
                    <div className="single-product-heading text-right">
                      <span>Amount</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                {topupData?.loading ? (
                  <Loading />
                ) : (
                  <div className="product-table">
                    <div className="product-table-area">
                      {topupData?.data?.topUps?.length ? (
                        topupData?.data?.topUps?.map((item, index) => (
                          <React.Fragment key={index}>
                            <div
                              className="single-product-wrapper"
                              onClick={() => setSelectedData(item)}
                            >
                              <div className="single-product">
                                <span className="name">{item?.name}</span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  {item?.mobileNumber}
                                </span>
                              </div>

                              <div className="single-product">
                                <span className="name">
                                  {item?.designation}
                                </span>
                              </div>

                              <div className="single-product">
                                <span className="name">{item?.topUpId}</span>
                              </div>

                              <div className="single-product">
                                <div className="name">
                                  <span
                                    className={`radius-btn ${item?.status?.toLowerCase()}-btn`}
                                  >
                                    {item?.status}
                                  </span>
                                </div>
                              </div>

                              <div className="single-product justify-content-end">
                                <span className="name text-right">
                                  &#2547;{item?.amount}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        ))
                      ) : (
                        <Empty />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </CorporateLayout>

      <Drawer
        destroyOnClose={true}
        title="Details"
        width={500}
        onClose={onClose}
        visible={!!selectedData}
        bodyStyle={{ paddingBottom: 0 }}
        footer={
          <div
            style={{
              textAlign: "left",
            }}
          ></div>
        }
      >
        <div className="inner-body-wrapper">
          <div className="inner-body">
            <div className="single">
              <div className="info-name">
                <span>Date</span>
              </div>
              <div className="info-desc">
                <span>{moment(selectedData?.createdAt).format("lll")}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>TopUp Id</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.topUpId}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>vrGUID</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.vrGUID}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Name</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.name}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Mobile Number</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.mobileNumber?.split("+88")}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Designation</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.designation}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Amount</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.amount}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Operator</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.operator}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Type</span>
              </div>

              <div className="info-desc">
                <span>{`${selectedData?.type?.replace("_", " ")}`}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Gateway Name</span>
              </div>

              <div className="info-desc">
                <span>{selectedData?.gatewayName}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Request TopUp Status</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.requestTopUpStatus}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Status</span>
              </div>
              <div className="info-desc">
                <span
                  className={`radius-btn ${selectedData?.status?.toLowerCase()}-btn`}
                >
                  {selectedData?.status}
                </span>
              </div>
            </div>

            {selectedData?.paymentGateway && (
              <div className="single">
                <div className="info-name">
                  <span>Payment Gateway</span>
                </div>
                <div className="info-desc">
                  <span>{selectedData?.paymentGateway}</span>
                </div>
              </div>
            )}

            {selectedData?.failedReason && (
              <div className="single">
                <div className="info-name">
                  <span>Failed Reason</span>
                </div>
                <div className="info-desc">
                  <span>{selectedData?.failedReason}</span>
                </div>
              </div>
            )}

            <div className="single">
              <div className="info-name">
                <span>Created Response</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.createdResponse}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Initiated Response</span>
              </div>
              <div className="info-desc">
                <span>{selectedData?.initiatedResponse}</span>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </React.Fragment>
  );
};

export default TopUpDetailsList;
